module.exports = __webpack_public_path__ + "static/media/blog-1.b0903c4b.jpg";